import React from "react";
import ContentLoader from "react-content-loader";

const EventsLoader = (props) => (
  <ContentLoader
    width={700}
    height={300}
    viewBox="0 0 700 300"
    backgroundColor="#f5f5f5"
    foregroundColor="#dbdbdb"
    {...props}
  >
    <rect x="4" y="8" rx="3" ry="3" width="7" height="288" />
    <rect x="6" y="289" rx="3" ry="3" width="669" height="8" />
    <rect x="670" y="9" rx="3" ry="3" width="6" height="285" />
    <circle cx="160" cy="155" r="70" />
    <rect x="330" y="90" rx="3" ry="3" width="9" height="9" />
    <rect x="350" y="90" rx="3" ry="3" width="300" height="9" />
    <rect x="330" y="120" rx="3" ry="3" width="9" height="9" />
    <rect x="350" y="120" rx="3" ry="3" width="300" height="9" />
    <rect x="330" y="150" rx="3" ry="3" width="9" height="9" />
    <rect x="350" y="150" rx="3" ry="3" width="300" height="9" />
    <rect x="330" y="180" rx="3" ry="3" width="9" height="9" />
    <rect x="350" y="180" rx="3" ry="3" width="300" height="9" />
    <rect x="330" y="210" rx="3" ry="3" width="9" height="9" />
    <rect x="350" y="210" rx="3" ry="3" width="300" height="9" />
    <rect x="5" y="8" rx="3" ry="3" width="669" height="7" />
    
  </ContentLoader>
);

// EventsLoader.metadata = {
//   name: 'Sridhar Easwaran',
//   github: 'sridhareaswaran',
//   description: 'Events',
//   filename: 'EventsLoader',
// }

export default EventsLoader;
